// STYD: add-ons (extra koopjes) direct in de winkelwagen leggen, op de productpagina en in de winkelwagen.
// Markup: snippets/styd-addon-item.liquid. De side cart opent niet; de winkelwagen, het bolletje en de ring
// om het tasje worden op de achtergrond opnieuw getekend. Op /cart worden ook de pagina-secties bijgewerkt.
// Tracking: de regel krijgt de verborgen eigenschap _add_on (waar hij is toegevoegd); die staat ook op de bestelling.
(function () {
  if (window.stydAddonsReady) return;
  window.stydAddonsReady = true;

  function sectionsToRender() {
    const list = [];
    if (document.getElementById('CartDrawer')) {
      list.push({ section: 'cart-drawer', target: '#CartDrawer', selector: '#CartDrawer' });
    }
    list.push({ section: 'cart-icon-bubble', target: '#cart-icon-bubble', selector: '.shopify-section' });
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    if (items) list.push({ section: items.dataset.id, target: '#main-cart-items .js-contents', selector: '.js-contents' });
    if (footer) list.push({ section: footer.dataset.id, target: '#main-cart-footer .js-contents', selector: '.js-contents' });
    return list;
  }

  function render(state, sections) {
    if (!state.sections) return;
    sections.forEach((item) => {
      const html = state.sections[item.section];
      const target = document.querySelector(item.target);
      if (!html || !target) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(item.selector);
      if (source) target.innerHTML = source.innerHTML;
    });

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
    }
    const cartItems = document.querySelector('cart-items');
    if (cartItems) cartItems.classList.remove('is-empty');
    document.getElementById('main-cart-footer')?.classList.remove('is-empty');
  }

  // Event voor klantgebeurtenissen (Instellingen > Klantgebeurtenissen), bijv. om door te sturen naar GA4.
  function track(variantId, source, addon) {
    try {
      window.Shopify?.analytics?.publish?.('styd_addon_added', {
        variant_id: variantId,
        product_title: addon?.querySelector('.styd-addon__title')?.textContent.trim() || '',
        price: addon?.querySelector('[data-styd-addon-price]')?.textContent.trim() || '',
        source,
      });
    } catch (error) {
      // Tracking mag het toevoegen nooit breken
    }
  }

  async function add(button) {
    const addon = button.closest('[data-styd-addon]');
    const select = addon?.querySelector('[data-styd-addon-variant]');
    const variantId = Number(select ? select.value : button.dataset.variantId);
    if (!variantId) return;
    const source = button.dataset.source || 'Add-on';

    const sections = sectionsToRender();
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _add_on: source } }],
          sections: sections.map((item) => item.section),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || response.statusText);

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      render(state, sections);
      track(variantId, source, addon);
      setTimeout(() => button.classList.remove('is-added'), 2500);
    } catch (error) {
      // Lukt direct toevoegen niet (bijv. voorraad), stuur de klant naar de productpagina.
      const link = addon?.querySelector('.styd-addon__title');
      if (link) window.location.href = link.href;
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-styd-addon-add]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    add(button);
  });

  function syncAddon(addon, select) {
    const option = select.selectedOptions[0];
    const priceEl = addon.querySelector('[data-styd-addon-price]');
    const labelEl = addon.querySelector('[data-styd-addon-variant-label]');
    if (option?.dataset.price && priceEl) priceEl.textContent = option.dataset.price;
    if (option && labelEl) labelEl.textContent = option.textContent.trim();
    const image = addon.querySelector('[data-styd-addon-image]');
    if (option?.dataset.image && image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
  }

  // Prijs (en label) volgt de gekozen maat/kleur
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-styd-addon-variant]');
    if (!select) return;
    const addon = select.closest('[data-styd-addon]');
    if (addon) syncAddon(addon, select);
  });

  // Kleurmatch op de productpagina: kiest de klant zilver of goud, dan wisselen de add-ons mee.
  // Zelfde herkenning als snippets/styd-metal.liquid.
  function metalOf(text) {
    const t = String(text || '').toLowerCase();
    if (t.includes('zilver') || t.includes('silver')) return 'zilver';
    if (t.includes('goud') || t.includes('gold')) return 'goud';
    return '';
  }

  function applyMetal(variant) {
    document.querySelectorAll('.styd-upsell').forEach((upsell) => {
      const metal = metalOf(variant?.title) || metalOf((variant?.options || []).join(' ')) || upsell.dataset.stydProductMetal || '';
      if (!metal) return;
      upsell.querySelectorAll('[data-styd-addon]').forEach((addon) => {
        // Apart product per kleur: alleen de passende kleur tonen
        const own = addon.dataset.stydAddonMetal;
        if (own) addon.hidden = own !== metal;
        // Varianten in goud/zilver: de passende variant kiezen
        const select = addon.querySelector('[data-styd-addon-variant]');
        if (select && addon.hasAttribute('data-styd-addon-metal-variants')) {
          const match = [...select.options].find((option) => option.dataset.metal === metal);
          if (match && select.value !== match.value) {
            select.value = match.value;
            syncAddon(addon, select);
          }
          // Label alleen als de kleur past; anders het keuzemenu, zodat de klant zelf kiest
          if (addon.hasAttribute('data-styd-addon-metal-choice')) {
            addon.classList.toggle('styd-addon--metal-only', Boolean(match));
          }
        }
      });
      // Geen enkele add-on zichtbaar? Dan het hele blok weg, ook de titel.
      upsell.hidden = !upsell.querySelector('[data-styd-addon]:not([hidden])');
    });
  }

  // Slider in de winkelwagen: pijltjes en voortgangsbalkje
  function updateSlider(slider) {
    const track = slider.querySelector('[data-styd-addons-track]');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    const prev = slider.querySelector('[data-styd-addons-scroll="-1"]');
    const next = slider.querySelector('[data-styd-addons-scroll="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    const arrows = slider.querySelector('.styd-cart-addons__arrows');
    if (arrows) arrows.hidden = max <= 2;
    const bar = slider.querySelector('[data-styd-addons-progress]');
    if (bar) {
      const share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      bar.parentElement.hidden = share >= 0.99;
      bar.style.width = `${share * 100}%`;
      bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (1 / share - 1) * 100 : 0}%)`;
    }
  }

  function updateSliders() {
    document.querySelectorAll('[data-styd-addons-slider]').forEach(updateSlider);
  }

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-styd-addons-scroll]');
    if (!arrow) return;
    const slider = arrow.closest('[data-styd-addons-slider]');
    const track = slider?.querySelector('[data-styd-addons-track]');
    const card = track?.querySelector('[data-styd-addon]');
    if (!track || !card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    track.scrollBy({ left: Number(arrow.dataset.stydAddonsScroll) * step, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target.closest?.('[data-styd-addons-track]');
      if (track) updateSlider(track.closest('[data-styd-addons-slider]'));
    },
    true
  );

  // De winkelwagen wordt vaak opnieuw getekend (aantal, verwijderen, add-on): daarna de slider bijwerken
  // (ook als de side cart opengaat, want dan krijgt de slider pas zijn breedte). Eén keer per frame.
  let sliderFrame = 0;
  const scheduleSliders = () => {
    if (sliderFrame) return;
    sliderFrame = requestAnimationFrame(() => {
      sliderFrame = 0;
      updateSliders();
    });
  };
  new MutationObserver(scheduleSliders).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  document.addEventListener('transitionend', (event) => {
    if (event.target.closest?.('cart-drawer')) scheduleSliders();
  });
  window.addEventListener('resize', updateSliders);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSliders);
  } else {
    updateSliders();
  }

  function listenForVariants() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => applyMetal(event.data?.variant));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', listenForVariants);
  } else {
    listenForVariants();
  }
})();
